module.exports = __webpack_public_path__ + "img/studio-background@2x.bdab674f.png";